import classnames from 'classnames';
import React from 'react';

interface SeparatorProps {
  className?: string;
  isVertical?: boolean;
  showBorder?: boolean;
}
export const Separator: React.FC<SeparatorProps> = ({ className, isVertical = false, showBorder = false }) => (
  <span
    role="separator"
    className={classnames('header__action-bar__separator', className, {
      'header__action-bar__separator--vertical': isVertical,
      'header__action-bar__separator--with-border': showBorder,
    })}
  />
);
